import useUTMData from '@otovo/shared/hooks/useUTMData';
import useCampaignValidator from '../../hooks/useCampaignValidator';
import DiscountBanner from './DiscountBanner';
import WelcomeBack from './WelcomeBack/WelcomeBack';

type Props = {
  children?: JSX.Element;
};

const LandingPageNotification = ({ children }: Props) => {
  const utmData = useUTMData();
  const { validatedCampaign } = useCampaignValidator({ utm_data: utmData });

  if (children) {
    return children;
  }

  if (validatedCampaign?.discounts) {
    return <DiscountBanner discounts={validatedCampaign.discounts} />;
  }

  return <WelcomeBack />;
};

export default LandingPageNotification;
